import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Dropdown } from "react-bootstrap";
import coins from "../../../coins";
import socket from "../../../../Socket";
import storage from "../../../../Storage";
import { setCoin, gameCoin, setCredit } from "../../../../actions/gameCoin";
import { __, wait, decode, encode, forceSatoshiFormat, Event } from "../../../../Helper";
import C from "../../../../Constant";

import RollingBalance from "../../../Components/Common/RollingBalance";

class Credit extends React.Component {
    constructor(props) {
        super(props);
        // Helper to extract numeric credit value from storage (may be number or object)
        const storedCredit = storage.getKey('credit');
        const initialCredit = typeof storedCredit === 'object'
            ? (storedCredit?.kshs ?? 0)
            : (storedCredit ?? 0);

        this.state = {
            token: storage.getKey('token'),
            coin: storage.getKey('coin') ? storage.getKey('coin') : "BTC",
            credits: {},
            coins: [],
            different: [],
            credit: initialCredit
        };
        this.selectCoin = this.selectCoin.bind(this);
        this.updateCredit = this.updateCredit.bind(this);
    }

    componentDidMount() {
        //Get Redux Coin
        this.props.gameCoin();

        if (this.state.token !== null)
            socket.emit(C.CREDIT, encode({ token: this.state.token, coin: this.state.coin }));

        socket.on(C.CREDIT, data => this.getCredit(decode(data)));
        socket.on(C.UPDATE_CREDIT, data => this.updateCredit(decode(data)));

        Event.on(C.UPDATE_CREDIT, data => this.updateCredit(data));
    }

    componentWillUnmount() {
        Event.off(C.UPDATE_CREDIT, this.updateCredit);
    }

    getCredit(data) {
        let { credit } = data;
        this.setState({ credits: credit });

        // Use 'kshs' key directly from data to match server response format
        let currentCredit = credit?.kshs ?? 0;
        this.setState({ credit: currentCredit });

        storage.setKey('credit', currentCredit);
        //Set for Redux
        this.props.setCredit(currentCredit);
        this.updateAllCoins();
    }

    updateCredit(data) {
        let credit = data.value;
        let coin = data.coin;

        let different;
        let arr;

        if (__.toNumber(credit) > __.toNumber(this.state.credit)) {
            different = __.toNumber(credit) - __.toNumber(this.state.credit);
            arr = {
                amount: different,
                color: 'text-success'
            }
        }
        else {
            different = __.toNumber(this.state.credit) - __.toNumber(credit);
            arr = {
                amount: different,
                color: 'text-danger'
            }
        }

        let check = forceSatoshiFormat(different);

        if (check.toString() !== '0.00000000') {
            this.setState(state => ({ different: [arr, ...state.different] }));
        }

        this.setState({ credit: credit });
        storage.setKey('credit', credit);
        this.updateCoin(__.lowerCase(coin), credit);

        //Set for Redux
        this.props.setCredit(credit);
    }

    updateCoin(coin, amount) {
        this.setState({ coins: [] });

        coins.forEach((item, i) => {
            if (__.lowerCase(item.preffix) === coin) {
                let update = <span onClick={e => this.selectCoin(__.upperCase(coin))} key={__.toString(i)} className={"animated slideInDown num-style"}>
                    {/* <img src={'/assets/images/' + item.image} alt="coin" className={'mini-coin-2'} /> */}
                    {/* {item.preffix}:  */}
                    KES <br />
                    <RollingBalance value={amount} /></span>;
                this.setState(state => ({ coins: [update, ...state.coins] }));
            }
            else {
                let value = this.state.credits[__.lowerCase(item.preffix)];
                let update = <span onClick={e => this.selectCoin(item.preffix)} key={__.toString(i)} className={"animated slideInDown num-style"}>
                    {/* <img src={'/assets/images/' + item.image} alt="coin" className={'mini-coin-2'} /> */}
                    {/* {item.preffix}:  */}
                    KES <br />
                    <RollingBalance value={value} /></span>;
                this.setState(state => ({ coins: [update, ...state.coins] }));
            }
        });
    }

    updateAllCoins() {
        this.setState({ coins: [] });
        coins.forEach((item, i) => {
            let value = this.state.credits[__.lowerCase(item.preffix)];
            let coin = <span onClick={e => this.selectCoin(item.preffix)} key={__.toString(i)} className={"animated slideInDown num-style"}>
                {/* <img src={'/assets/images/' + item.image} alt="coin" className={'mini-coin-2'} /> */}
                KES <br />
                {/* {item.preffix}:  */}
                <RollingBalance value={value} /></span>;
            this.setState(state => ({ coins: [coin, ...state.coins] }));
        });
    }

    selectCoin(name) {
        //Fix For Double selection
        if (storage.getKey('coin') === name) return;
        storage.setKey('coin', name);

        let credit = this.state.credits[__.lowerCase(name)];
        this.setState({ coin: name, credit: credit });

        //Set Coin For Redux
        this.props.setCoin(name);
        this.props.setCredit(credit);
    }

    addDiff(data, i) {
        let id = 'id_' + Math.floor(Math.random() * 1000 + 1);

        wait(2000).then(() => {
            this.state.different.splice(i, 1);
            try {
                document.getElementById(id).classList.remove('frd');
                document.getElementById(id).classList.add('fadeOutDown');
            }
            catch (e) { }

        });

        return (
            <>
                <li id={id} className={'list-inline w-100 text-right animated frd ' + data.color}> {(data.color === 'text-danger' ? '-' : '+')}
                    {forceSatoshiFormat(data.amount, this.state.coin)}
                </li>
            </>
        );
    }

    render() {
        let { credit, different, coin } = this.state;
        let diff = different.map((data, i) =>
            this.addDiff(data, i)
        );
        return (
            <div className="header-balance-pill" ref={this.wrapperRef}>
                <div className="balance-label">KES</div>
                <div className="balance-value">
                    <RollingBalance value={credit} />
                </div>
                <ul id="cup" className="list-inline m-0 position-absolute" style={{ top: '-25px', right: '10px' }}>{diff}</ul>
            </div>
        );
    }
}

Credit.propTypes = {
    setCoin: PropTypes.func.isRequired,
    coin: PropTypes.string
};

const mapStateToProps = state => ({
    coin: state.items.coin
});

export default connect(mapStateToProps, { setCoin, gameCoin, setCredit })(Credit);